import { render, staticRenderFns } from "./ContentLoaderBookingPassengerMobile.vue?vue&type=template&id=c94321c2&"
import script from "./ContentLoaderBookingPassengerMobile.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderBookingPassengerMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports